import React, { useState } from 'react';
import { useApolloClient } from 'react-apollo';
import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import {
  FIND_ALL_ESTADOS,
  FIND_ALL_MUNICIPIO,
} from '../../../../../graphql/queryes';
import {
  TextField,
  TextFieldSearch,
} from '../../../../../components/TextField';
import ApolloInstance from '../../../../../apollo/setup';

export const EnderecoForm = ({ handleDadosCadastrais, dadosCadastrais }) => {
  const [colorLabelInputEstado, setColorLabelInputEstado] = useState('#868686');
  const [colorLabelInputMunicipio, setColorLabelInputMunicipio] =
    useState('#868686');

  const client = useApolloClient();

  const handleLoadMoreOptions = async ({
    variables,
    query,
    responseObject,
  }) => {
    const response = await client.query({
      query,
      variables,
    });

    const pageNumber = variables?.pageableDTO?.pageNumber || 0;
    const { content, last } = response?.data?.[responseObject];

    return {
      options: content,
      hasMore: !last,
      additional: {
        page: pageNumber + 1,
      },
    };
  };

  const loadMunicipios = async (search, _, { page }) => {
    return handleLoadMoreOptions({
      variables: {
        searchDTO: {
          search: search || '',
          ativo: true,
        },
        pageableDTO: {
          pageNumber: page,
          pageSize: 30,
          sortField: 'nome',
          sortDir: 'ASC',
        },
      },
      responseObject: 'findAllMunicipio',
      query: FIND_ALL_MUNICIPIO,
    });
  };
  const loadEstados = async (search, _, { page }) => {
    return handleLoadMoreOptions({
      variables: {
        searchDTO: {
          search: search || '',
          ativo: true,
        },
        pageableDTO: {
          pageNumber: page,
          pageSize: 30,
          sortField: 'nome',
          sortDir: 'ASC',
        },
      },
      responseObject: 'findAllEstado',
      query: FIND_ALL_ESTADOS,
    });
  };
  const campos = [
    {
      label: 'Logradouro',
      placeholder: 'Digite o Logradouro',
      key: 'nomeLogradouro',
      xs: 12,
    },
    {
      label: 'Bairro',
      placeholder: 'Digite o bairro',
      key: 'bairro',
      xs: 12,
    },
    {
      label: 'Cep',
      placeholder: 'Digite o cep',
      key: 'cep',
      mask: 'cep',
      xs: 6,
    },
    {
      label: 'Número',
      placeholder: 'numero',
      key: 'numero',
      xs: 6,
    },
  ];

  return (
    <ApolloInstance>
      <Grid
        container
        spacing={2}
        style={{
          padding: '0px',
          margin: '0px',
          width: '100%',
        }}
      >
        <Subtitle>Informe o endereço:</Subtitle>
        {campos.map((campo) => (
          <Grid item xs={campo.xs} key={campo.key}>
            <TextField
              label={campo.label}
              placeholder={campo.placeholder}
              value={dadosCadastrais?.endereco?.[campo.key]}
              mask={campo.mask}
              type={campo.key === 'numero' && 'number'}
              onChange={(e) =>
                handleDadosCadastrais(
                  { ...dadosCadastrais.endereco, [campo.key]: e.target.value },
                  'endereco'
                )
              }
            />
          </Grid>
        ))}
        <Grid item xs={6}>
          <LabelField
            component="label"
            style={{ color: colorLabelInputEstado }}
          >
            {'Estado'}
          </LabelField>
          <TextFieldSearch
            placeholder="Estado"
            loadOptions={loadEstados}
            withPaginate
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            value={dadosCadastrais?.endereco?.estado}
            onChange={(e) =>
              handleDadosCadastrais(
                { ...dadosCadastrais.endereco, estado: e },
                'endereco'
              )
            }
            onFocus={() => setColorLabelInputEstado('#26ACA9')}
            onBlur={() => setColorLabelInputEstado('#868686')}
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelField
            component="label"
            style={{ color: colorLabelInputMunicipio }}
          >
            Cidade
          </LabelField>
          <TextFieldSearch
            key={dadosCadastrais?.endereco?.estado}
            placeholder="Município"
            value={dadosCadastrais?.endereco?.municipio}
            onChange={(e) =>
              handleDadosCadastrais(
                { ...dadosCadastrais.endereco, municipio: e },
                'endereco'
              )
            }
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            loadOptions={loadMunicipios}
            onFocus={() => setColorLabelInputMunicipio('#26ACA9')}
            onBlur={() => setColorLabelInputMunicipio('#868686')}
            withPaginate
            additional={{
              page: 0,
            }}
            debounceTimeout={300}
          />
        </Grid>
      </Grid>
    </ApolloInstance>
  );
};

const Row = styled.div`
  display: flex;
  gap: 5px;
`;
const Subtitle = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
`;

const LabelField = styled.label`
  color: #868686;
  font-size: 12px;
  height: 16px;
`;
